import { Component, OnInit, Renderer2 } from '@angular/core';
import {TrackingService} from '../../services/tracking.service';
import {ViewTextesLegauxComponent} from '../../modules/textes-legaux/view-textes-legaux/view-textes-legaux.component';
import {MatDialog} from '@angular/material';
import {FormBuilder, FormGroup, NgForm, Validators} from '@angular/forms';
import {LoaderService} from '../../services/loader.service';
import {
  OapErrorMessages,
  ConfirmValidParentMatcher,
  CustomValidatorsModule,
  OapStandarErrorStateMatcher,
  SupportOfflineErrorMessages
} from '../../modules/custom-validators/custom-validators.module';
import {first} from 'rxjs/operators';
import {PatientService} from '../../services/patient.service';
import {SupportOffline} from '../../models/SupportOffline';
import {AlertService} from '../../services/alert.service';
import {Router} from '@angular/router';

@Component({
  selector: 'oap-support',
  templateUrl: './support-offline.component.html',
  styleUrls: ['./support-offline.component.scss']
})
export class SupportOfflineComponent implements OnInit {
  public hideContent: boolean;
  public animCurrentlyPlaying: boolean;
    supportOfflineForm: FormGroup;
    submitted = false;
    validation_support = SupportOfflineErrorMessages;
    matcher = new OapStandarErrorStateMatcher();
    confirmValidParentMatcher = new ConfirmValidParentMatcher();
    submitLoading = false;
    patientId: number;
    subjectsList: any;
    public mask = [/[1-4,7-8]/, ' ', /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /[0-9A-B]/, ' ',
        /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/];
    public maskTel = [/\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/];
    alertMessageSendedShowed = false;

  constructor(
      private renderer: Renderer2,
      private dialog: MatDialog,
      private loaderService: LoaderService,
      private formBuilder: FormBuilder,
      public tracking: TrackingService,
      private patientService: PatientService,
      private alertService: AlertService,
  ) {
    this.subjectsList = [];
  }

  ngOnInit() {
    this.infoSupportOffline();
    this.alertService.clear();
    this.patientId = parseInt(JSON.parse(localStorage.getItem('patientId')));
    this.getSubjects();
  }
  expandables(e) {
      e.stopPropagation();
      e.preventDefault();

      if (!this.animCurrentlyPlaying) {
          const $content = e.target.parentElement.children[2];
          this.animCurrentlyPlaying = true;

          if ($content.classList.contains('close')) {
              this.renderer.setStyle($content, 'height', $content.children[0].clientHeight + 'px');
              this.renderer.removeClass($content, 'close');
              this.renderer.addClass($content, 'open');
          } else {
              this.renderer.setStyle($content, 'height', '0');
              this.renderer.removeClass($content, 'open');
              this.renderer.addClass($content, 'close');
          }

          this.animCurrentlyPlaying = false;
      }
  }
  loadMentionsLegales() {
      //console.log('*** load Mentions légales ***');
      const dialogRef = this.dialog.open(ViewTextesLegauxComponent,
          {
              disableClose: false,
              data: {
                  typeTexte: 'ml'
              }
          }
      );
  }

    private infoSupportOffline(){
        this.supportOfflineForm = this.formBuilder.group({
            supportFirstname: ['', [Validators.required]],
            supportLastname: ['', [Validators.required]],
            matchingEmails: this.formBuilder.group({
                supportEmail: ['', [Validators.required,
                    Validators.minLength(5),
                    Validators.maxLength(256),
                    Validators.email]],
                supportEmailConfirmation: ['', Validators.required]
            }, {
                validator: (formGroup: FormGroup) => {
                    const ret = CustomValidatorsModule.areEqual(formGroup);
                    // console.log('validator matchingEmails : ' + ret);
                    return ret;
                }
            }),
            supportText: ['', [Validators.required]],
            supportSubject: ['', [Validators.required]],
            cgu: ['', [Validators.required]],
        });
    }

   getSubjects() {
     this.patientService.getSupportOfflineSubjects().pipe(first())
      .subscribe(
        data => {
          this.subjectsList = data;
        },
        error => {
        });
   }

  onFormSubmit(form) {
    if (this.supportOfflineForm.invalid) {
        return;
    }

    this.submitLoading = true;
    this.submitted = true;
    const supportOfflineFormContent: SupportOffline = {
      prenom:  form.controls.supportFirstname.value,
      nom:  form.controls.supportLastname.value,
      emailPourReponse:  form.controls.matchingEmails.controls.supportEmail.value,
      question:  form.controls.supportText.value,
      supportSujetKey: form.controls.supportSubject.value,
    };

    this.patientService.supportOfflineRequest(supportOfflineFormContent)
      .pipe(first())
      .subscribe(
        data => {
          form.reset();
          this.alertMessageSendedShowed = true;
          this.submitLoading = false;
        },
        error => {
          this.alertService.error(error);
          this.submitLoading = false;
        });
  }
}
